<template>
	<div class="container2">
		<div class="main-img">
			<el-carousel :interval="5000" arrow="always" class="main-img-all">
				<el-carousel-item v-for="(item,index) in imgList" :key="index" class="main-img-lb">
					<el-image class="main-img1"
						:src="item.img"></el-image>
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="menu">
			<div class="menu1">热度集团深圳总部，惠州工厂，源头厂家</div>
			<div class="menu2">超甲级写字楼的总部，位于深圳，现代化生产工厂位于惠州，一站式共享项目服务</div>
			<div class="menu3">
				<div class="menu3-img">
					<!-- <el-video class="menu3-img1" src="" poster="../../assets/logo.png" controls></el-video> -->
				</div>
			</div>
		</div>
		<div class="cable">
			<div class="cable1">
				<el-image class="cable1-img" :src="require('../../assets/img/main/1.jpeg')"></el-image>
			</div>
			<div class="cable2">
				<div class="cable2-text">
					<span class="cable2-text1">热度</span>
					<span class="cable2-text1 cable2-text2">共享充电宝</span>
					<span class="cable2-text1">代理加盟-热度科技</span>
				</div>
				<div class="cable2-text3">
					<span>主营热度共享充电宝，密码式倍电</span>
					<span class="cable2-text3-1">共享充电线</span>
					<span>，4口，8口，12口，16口，20口，24口共享充电宝机柜，也有32口，40口立式共享充电宝广告机，热度充电宝采取5000毫安电池
					，支持3U口输出，安卓苹果手机均支持，代理无需加盟费，无需押金，24小时售后扶植。</span>
					<span class="cable2-text3-2">新项目共享WiFi贴</span>
					<span>，火爆招商中。</span>
				</div>
				<div class="cable2-text4">热度集团-深圳市热度科技有限公司-企业文化</div>
				<div class="cable2-text5">
					<div class="cable2-text5-1">目标：帮助一亿创业者走向成功</div>
					<div class="cable2-text5-1">口号：我们都是创业者，我们都做追梦人</div>
					<div class="cable2-text5-1">行为准则：说我所做，做我所说，说到做到</div>
					<div class="cable2-text5-1">使命：让创业更简单，让奋斗者更幸福</div>
					<div class="cable2-text5-1">愿景：打造一个最有创造力的事业平台</div>
					<div class="cable2-text5-1">核心价值观：爱国，和谐，富有，诚信，敬业</div>
				</div>
			</div>
		</div>
		<div class="statistics">
			<div class="statistics1">
				<div class="statistics1-text">
					<div class="statistics1-text1">热度集团</div>
					<div class="statistics1-text2">团队</div>
				</div>
				<div class="statistics1-text">
					<div class="statistics1-text1">
						<span class="statistics1-text1">10000</span>
						<span class="statistics1-text2">多名</span>
					</div>
					<div class="statistics1-text2">代理商</div>
				</div>
				<div class="statistics1-text">
					<div class="statistics1-text1">
						<span class="statistics1-text1">55</span>
						<span class="statistics1-text2">多万</span>
					</div>
					<div class="statistics1-text2">共享充电宝铺货量</div>
				</div>
				<div class="statistics1-text">
					<div class="statistics1-text1">
						<span class="statistics1-text1">2300</span>
						<span class="statistics1-text2">多名</span>
					</div>
					<div class="statistics1-text2">销售招商客服人员</div>
				</div>
			</div>
		</div>
		<div class="agentjoin">
			<div class="agentjoin1">热度科技-热度充电宝代理加盟</div>
			<div class="agentjoin2">Please enter the main title.</div>
			<div class="advantage1">
				<div class="advantage1-all">
					<div class="advantage1-all-img">
						<img
							src="//16856361.s21i.faiusr.com/4/ABUIABAEGAAgzsLT5gUol9n1xwQwsAk4sAk!300x300.png.webp" />
					</div>
					<div class="advantage1-all-text">
						<div class="advantage1-all-text1">支持共享充电宝OEM</div>
						<div class="advantage1-all-text2">
							支持全球共享充电宝OEM充电宝租赁机，共享充电宝广告机，共享充电线贴牌定制，交期快，终身售后分润100%后续免费升级维护
						</div>
					</div>
				</div>
				<div class="advantage1-all">
					<div class="advantage1-all-img">
						<img
							src="//16856361.s21i.faiusr.com/4/ABUIABAEGAAg5sLT5gUosd7i9wUwsAk4sAk!300x300.png.webp" />
					</div>
					<div class="advantage1-all-text">
						<div class="advantage1-all-text1">快速回本</div>
						<div class="advantage1-all-text2 advantage1-color-text">
							倍电代理商无创业风险，无需代理费和押金，只需花钱购买设备就可代理，一台设备2个月可以回本。保证代理商本金安全。
						</div>
					</div>
				</div>
				<div class="advantage1-all">
					<div class="advantage1-all-img">
						<img
							src="//16856361.s21i.faiusr.com/4/ABUIABAEGAAg-8LT5gUopbeYigIwsAk4sAk!300x300.png.webp" />
					</div>
					<div class="advantage1-all-text">
						<div class="advantage1-all-text1">总部扶植</div>
						<div class="advantage1-all-text2">
							热度采取总部招商政策，只要前期加入，均给予总部垂直政策扶植，定期线上线下培训，推广策划支持，资质证明，商家协议等。
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="profile">
			<div class="profile1">
				<div class="profile1-text1">深圳市热度科技位于深圳，注册资金1000万，项目初期天使投资3亿元，公司有自己的研发部，招商部，策划部，产品拓展部
				，风控运营部门，法务部，客服部门等组成，团队成员2300多人，6年支付行业服务诚信企业，热度全国招募代理商。</div>
				<div class="profile1-text1">热度作为共享充电宝行业的后起之秀，2019年，2020年，2021年连续多次荣获全球十大共享充电宝之一，
				公司致力于发展共享经济，人人创业，轻资产模式的代理模式，以服务大众为公司宗旨。</div>
				<div class="profile1-text1">2021年3月，热度全国总出货量超过38万台，3月28日，热度获得A轮融资1亿元，全面发展酒店新零售项目和提高线下覆盖率。
				2021年10月，热度全国覆盖率高达85%，点亮超过几十万台设备。</div>
				<div class="profile1-text1">产品包括组合式共享充电宝机柜，叠加式共享充电宝，桌面式共享充电宝机柜，立式共享充电宝多媒体广告机，酒店网吧用共享充电线
				，酒店智能售货机支持OEM共享充电贴牌订制，提供一站式服务。</div>
				<div class="profile1-text2">招商总部：广东深圳  生产厂家：广东惠州</div>
				<div class="profile1-text2">共享充电宝 | 共享充电线 | 共享WiFi贴 | 酒店售后机厂家招商</div>
			</div>
			<div class="profile2"></div>
		</div>
		
		<div class="fotter">
			<div class="fotter1">
				<div class="fotter1-text">
					<span class="color-text3">热度</span>
					<span>官网-深圳市热度科技有限公司</span>
				</div>
				<div class="fotter1-text2">
					<div class="fotter1-text2-1">
						<span>热度-全球十大</span>
						<span class="color-text">共享充电宝</span>
						<span>品牌之一，</span>
						<span class="color-text2">热度快充充电宝支持22.5W超级快充</span>
					</div>
					<div class="fotter1-text2-2">
						<span class="fotter1-text2-2-left color-text3">共享充电线</span>
						<span>，共享充电宝加盟代理，</span>
						<span class="fotter1-text2-2-left color-text3">共享WiFi贴</span>
						<span>，酒店售货机厂家招商加盟</span>
					</div>
					<div class="fotter1-text2-3">
						<span>代理加盟咨询招商总监：王总 </span>
						<span class="color-text3">18664573264</span>
						<span> 微信同号</span>
					</div>
					<div class="fotter1-text2-4">
						<span>公司总部：广东省深圳市宝安区新桥街道上星社区上星路万科星城星宸大厦第1栋19楼整层</span>
					</div>
				</div>
			</div>
			<div class="fotter2">
				<el-image src="../../assets/img/erweim1.png"></el-image>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				imgList:[
					{
						id:1,
						img:require('../../assets/img/main/7.jpeg')
					},
					{
						id:2,
						img:require('../../assets/img/main/8.jpeg')
					},
					{
						id:3,
						img:require('../../assets/img/main/9.jpeg')
					},
				],
			}
		},
		methods: {
			
		}
	}
</script>

<style scoped>
	.container2 {
		background: #ffffff;
		padding-bottom: 20px;
	}
	
	.main-img-all {
		width: 100%;
	}
	
	.main-img-lb {
		/* height: 420px; */
	}
	
	.main-img1 {
		width: 100%;
		height: 440px;
	}
	
	::v-deep .el-carousel__container {
		min-height: 440px;
	}
	.menu{
		/* margin: 2% auto; */
		margin-top: 2%;
		padding-left: 12%;
		padding-right: 12%;
		background-image: url(//2.ss.faisys.com/image/materialLib/responsiveImage/8000317.png?v=201712181730);
		/* background-color: rgba(252, 253, 255, 1); */
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center center;
		padding-bottom: 5%;
		/* background-attachment: fixed; */
	}
	.menu1{
		text-align: center;
		line-height: 34px;
		color: rgb(51, 51, 51);
		font-family: 微软雅黑;
		font-size: 20px;
	}
	.menu2{
		font-size: 14px;
		color: rgb(102, 102, 102);
		margin-top: 2%;
	}
	.menu3{
		position: relative;
	}
	.menu3-img{
		background-image: url('../../assets/img/main/1.jpeg');
		width: 82%;
		height: 400px;
		margin: 2% auto;
		background-size: cover;
		background-position: 50%;
		background-repeat: no-repeat;
		background-size: contain;
		padding-bottom: inherit;
		transition: all .46s ease;
		width: 100%;
	}
	.menu3-img1{
	}
	.cable{
		/* margin-top: 3%; */
		padding-left: 10%;
		padding-right: 10%;
		display: flex;
		padding-bottom: 2%;
	}
	.cable1{
		width: 50%;
	}
	.cable1-img{
		width: 70%;
	}
	.cable2{
		width: 50%;
	}
	.cable2-text{
		text-align: left;
	}
	.cable2-text1{
		font-size: 24px;
		color: rgb(51, 51, 51);
		font-family: 微软雅黑;
	}
	.cable2-text2{
		color: rgb(73, 110, 232);
	}
	.cable2-text3{
		font-size: 16px;
		line-height: 26px;
		margin-top: 10px;
		text-align: left;
	}
	.cable2-text3-1{
		color: rgb(73, 110, 232);
	}
	.cable2-text3-2{
		color: rgb(230, 74, 25);
	}
	.cable2-text4{
		line-height: 30px;
		font-size: 20px;
		font-family: 微软雅黑;
		text-align: left;
		margin-top: 2%;
	}
	.cable2-text5{
		margin-top: 2%;
		text-align: left;
	}
	.cable2-text5-1{
		color: rgb(245, 81, 30);
		font-size: 16px;
		line-height: 30px;
	}
	.statistics{
		background-image: url(//2.ss.faisys.com/image/materialLib/responsiveImage/8000113.png?v=201712181730);
		background-color: #fff;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center center;
		padding-top: 5%;
		padding-bottom: 5%;
		padding-left: 5%;
	}
	.statistics1{
		display: flex;
		flex-wrap: nowrap;
		position: relative;
	}
	.statistics1-text{
		width: 15%;
		word-wrap: break-word;
		-webkit-text-size-adjust: 100%;
		clear: both;
		outline: 0;
		position: relative;
		white-space: pre-wrap;
		word-break: normal;
		/* margin-right: 4%; */
		text-align: left;
	}
	.statistics1-text1{
		font-size: 26px;
		color: rgb(51, 51, 51);
		font-family: 微软雅黑;
	}
	.statistics1-text2{
		font-size: 14px;
		color: rgb(51, 51, 51);
		font-family: 微软雅黑;
	}
	.agentjoin{
		margin-top: 2%;
		text-align: center;
	}
	.agentjoin1{
		font-size: 30px;
		color: rgb(43, 43, 43);
	}
	.agentjoin2{
		font-size: 12px;
		color: rgb(153, 153, 153);
		margin-top: 1%;
	}
	
	.advantage1 {
		display: flex;
		position: relative;
		margin-top: 20px;
		margin-left: 5%;
		margin-right: 5%;
		padding-top: 20px;
		flex-wrap: wrap;
	}
	.advantage1-all{
		width: 33%;
		max-width: 100%;
	}
	
	.advantage1-all-img img {
		width: 87px;
		height: 87px;
	}
	
	.advantage1-all-text1 {
		font-size: 20px;
		text-align: center;
	}
	
	.advantage1-all-text {
		width: 61%;
		line-height: 30px;
		margin: 15px auto;
	}
	
	.advantage1-all-text2 {
		font-size: 14px;
		/* color: rgb(153, 153, 153); */
	}
	.advantage1-color-text{
		color: rgb(30, 80, 174);
	}
	.profile{
		margin-top: 2%;
		display: flex;
		flex-wrap: nowrap;
		position: relative;
	}
	.profile1{
		width: 40%;
		background: linear-gradient(90deg, rgba(80,99,252,1), rgba(72,150,246,1));
		padding-left: 5%;
		padding-right: 5%;
		padding-top: 3%;
		padding-bottom: 3%;
	}
	.profile1-text1{
		font-size: 14px;
		color: rgb(255, 255, 255);
		margin-bottom: 4%;
		word-break: normal;
		text-align: left;
		line-height: 30px;
	}
	.profile1-text2{
		color: rgb(255, 255, 255);
		font-size: 18px;
		text-align: left;
	}
	
	.fotter{
		margin-top: 3%;
		padding-left: 12%;
		padding-right: 12%;
		display: flex;
	}
	.fotter1{
		width: 50%;
		text-align: left;
		line-height: 30px;
	}
	.fotter2{
		width: 50%;
	}
	.fotter1-text{
		font-size: 26px;
		color: rgb(51, 51, 51);
	}
	.fotter1-text2{
		margin-top: 3%;
	}
	.fotter1-text2-4{
		margin-top: 3%;
	}
	
	.color-text {
		color: rgb(30, 80, 174);
	}
	.color-text2 {
		color: rgb(230, 74, 25);
	}
	.color-text3{
		color: rgb(73, 110, 232);
	}
</style>